import React, { useState } from 'react';
import { Fab, Tooltip } from '@mui/material';
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';
import { useAuth } from '../../context/AuthContext';
import FeedbackDialog from './FeedbackDialog';
import { useAddon } from '../addons/useAddon';

/**
 * The feedback button, just left of the help ? button. It keeps MUI's default z-index, so open dialogs
 * cover it (unlike the ? button, which must work inside dialogs). Hidden when the feedback add-on is off.
 */
const FeedbackLauncher: React.FC = () => {
    const { isAuthenticated } = useAuth();
    const [open, setOpen] = useState(false);
    const on = useAddon('feedback');
    if (!isAuthenticated || !on) return null;
    return (
        <>
            <Tooltip title="Send feedback">
                <Fab
                    size="small"
                    color="default"
                    aria-label="Send feedback"
                    data-help="feedback.launcher"
                    onClick={() => setOpen(true)}
                    sx={{ position: 'fixed', bottom: 16, right: 72 }}
                >
                    <FeedbackOutlinedIcon />
                </Fab>
            </Tooltip>
            <FeedbackDialog open={open} onClose={() => setOpen(false)} />
        </>
    );
};

export default FeedbackLauncher;
